import React, { FC, memo } from 'react';
import { ProviderConfiguracao } from './configuracao.context';
//
export const Context: FC<any> = memo(({ children }) => (
    <ProviderConfiguracao>{children}</ProviderConfiguracao>
));
export default Context;
